module.exports = __webpack_public_path__ + "static/media/AvenirNext-Regular.869056a8.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/AvenirNext-Regular.woff
// module id = 80
// module chunks = 0